module.exports = __webpack_public_path__ + "img/family-go-into-screen.137817d4.png";